/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Collapse from '@mui/material/Collapse'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from 'context'
import { useState } from 'react'

function Sidenav() {
  const [controller] = useMaterialUIController()
  const { darkMode } = controller
  const [expandedProfile, setExpandedProfile] = useState(false)

  const sidenavItems = [
    {
      icon: 'person',
      label: 'profile',
      href: 'profile',
      nested: [
        { icon: 'info', label: 'Basic Info', href: 'basic-info' },
        { icon: 'settings', label: 'App Profiles', href: 'app-profiles' },
        { icon: 'support', label: 'Support Details', href: 'support-details' }
      ]
    },
    { icon: 'lock', label: 'Auth Configuration', href: 'auth-configuration' },
    { icon: 'lock', label: 'App Configuration', href: 'app-configuration' },
    {
      icon: 'navigation',
      label: 'Custom Page Navigation Customization',
      href: 'navigation-customiztion',
    },
    { icon: 'security', label: 'Plan Configuration', href: 'plan-configuration' },
    { icon: 'badge', label: 'App Setup', href: 'app-setup' },
    { icon: 'workflow', label: 'Workflow Management', href: 'workflow-management' },
    { icon: 'delete', label: 'Delete App', href: 'delete-app' },
  ]

  const handleProfileClick = () => {
    setExpandedProfile(!expandedProfile)
  }

  const renderSidenavItems = sidenavItems.map(({ icon, label, href, nested }, key) => {
    const itemKey = `item-${key}`

    return (
      <MDBox key={itemKey} component="li" pt={key === 0 ? 0 : 1}>
        <MDTypography
          component="a"
          href={nested ? '#' : `#${href}`}
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          onClick={nested ? handleProfileClick : undefined}
          sx={({
            borders: { borderRadius },
            functions: { pxToRem },
            palette: { light },
            transitions,
          }) => ({
            display: 'flex',
            alignItems: 'center',
            borderRadius: borderRadius.md,
            padding: `${pxToRem(10)} ${pxToRem(16)}`,
            transition: transitions.create('background-color', {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.shorter,
            }),

            '&:hover': {
              backgroundColor: light.main,
              cursor: 'pointer',
            },
          })}
        >
          <MDBox mr={1.5} lineHeight={1} color={darkMode ? 'white' : 'dark'}>
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
          {label}
          {nested && (
            <Icon fontSize="small" sx={{ ml: 'auto' }}>
              {expandedProfile ? 'expand_less' : 'expand_more'}
            </Icon>
          )}
        </MDTypography>

        {nested && (
          <Collapse in={expandedProfile} timeout="auto" unmountOnExit>
            <MDBox component="ul" pl={4} sx={{ listStyle: 'none' }}>
              {nested.map((nestedItem, nestedKey) => (
                <MDBox key={`nested-${nestedKey}`} component="li" pt={1}>
                  <MDTypography
                    component="a"
                    href={`#${nestedItem.href}`}
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    sx={({
                      borders: { borderRadius },
                      functions: { pxToRem },
                      palette: { light },
                      transitions,
                    }) => ({
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: borderRadius.md,
                      padding: `${pxToRem(10)} ${pxToRem(16)}`,
                      transition: transitions.create('background-color', {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.shorter,
                      }),

                      '&:hover': {
                        backgroundColor: light.main,
                      },
                    })}
                  >
                    <MDBox mr={1.5} lineHeight={1} color={darkMode ? 'white' : 'dark'}>
                      <Icon fontSize="small">{nestedItem.icon}</Icon>
                    </MDBox>
                    {nestedItem.label}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
          </Collapse>
        )}
      </MDBox>
    )
  })

  return (
    <Card
      sx={{
        borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
        position: 'sticky',
        top: '1%',
      }}
    >
      <MDBox
        component="ul"
        display="flex"
        flexDirection="column"
        p={2}
        m={0}
        sx={{ listStyle: 'none' }}
      >
        {renderSidenavItems}
      </MDBox>
    </Card>
  )
}

export default Sidenav